import state from "./moduleStatusState";
import mutations from "./moduleStatusMutations";
import actions from "./moduleStatusActions";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
};
